module.exports = __webpack_public_path__ + "img/enamad-logo.918230e.png";